import React, {createRef, useState, useContext} from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const RadioButtonGroup = (props) => {
  const [value, setValue] = useState(props.value);

  const radioButtons = props.buttons;

  const handleChange = (event) => {
    setValue(event.target.value);
    props.onChange(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <RadioGroup row aria-label={props.key} name={props.key} value={value} onChange={handleChange}>
        {radioButtons.map(button => {
          return(<FormControlLabel key={button.value} value={button.value} control={<Radio size={button.size} checked={props.value===button.value}/>} label={button.label} disabled={props.readOnly} />)
        })}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioButtonGroup;